import script from "./BalModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BalModal.vue?vue&type=script&lang=ts&setup=true"

import "./BalModal.vue?vue&type=style&index=0&id=28b2922e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28b2922e"]])

export default __exports__